module.exports = "/img/story-1.83d55ddf.png";